export const formatFollowUpDate = (dateString: string) => {
  const followUpDate = new Date(dateString);
  if (!isNaN(followUpDate.getTime())) {
    const istOffset = 5.5 * 60 * 60 * 1000;
    const istDate = new Date(followUpDate.getTime() + istOffset);

    // Extract day, month, and year
    const day = istDate.getUTCDate().toString().padStart(2, "0");
    const month = (istDate.getUTCMonth() + 1).toString().padStart(2, "0");
    const year = istDate.getUTCFullYear().toString().slice(-2); // Get last two digits of the year

    // Extract time and convert to 12-hour format
    let hours = istDate.getUTCHours();
    let minutes = istDate.getUTCMinutes();
    const period = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12; // Convert 24-hour format to 12-hour format

    return `${day}/${month}/${year} ${hours}:${minutes
      .toString()
      .padStart(2, "0")}${period.toLowerCase()}`;
  }
  return "Invalid Date";
};
